import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { likeNewsApi } from "core/http/service/news";
import { SCREEN } from "helper/roleChecker/Screens";
import {
  likeNewsFailed,
  likeNewsStart,
  likeNewsSuccess,
  setupData,
} from "../redux/likeNews";
import {
  likeNewsDataSelector,
  newsDetailDataSelector,
} from "../redux/selector";
import { getNewsDetailSuccess } from "../redux/getNewsDetail";

function* likeNews(action) {
  const data = yield select(likeNewsDataSelector);
  const newsDetail = yield select(newsDetailDataSelector);
  try {
    const { id } = action.payload;
    yield call(likeNewsApi, {
      id,
      screenCode: SCREEN.IP_009,
      type: "POST",
    });
    yield put({
      type: likeNewsSuccess.type,
    });

    yield put({
      type: setupData.type,
      payload: { status: !data },
    });
    yield put({
      type: getNewsDetailSuccess.type,
      payload: {
        ...newsDetail,
        totalLike: data ? newsDetail.totalLike - 1 : newsDetail.totalLike + 1,
      },
    });
  } catch (error: any) {
    yield put({
      type: likeNewsFailed.type,
    });
  }
}

function* watchLikeNews() {
  yield takeLatest(likeNewsStart.type, likeNews);
}

export default function* likeNewSaga() {
  yield all([watchLikeNews()]);
}
